import './Logo.css';

const Logo = () => {
    return(
        <a href={"#apresentation-section"}><div className="logo-wrapper">
            <label>ZUPA
                {/* <span>estúdio</span> */}
            </label>
        </div>
        </a>
    );
};

export default Logo;